import Expand from "@arcgis/core/widgets/Expand";
import { addBaseMapToggle } from "../../components/BaseMapToggle/BaseMapToggle";
import { HomeWidget } from "../../components/homeViewModel/HomeViewModel";
import { initLegend } from "../../components/Legend/Legend";
import { initLocate } from "../../components/locator/Locator";
import { Measurement } from "../../components/measurementViewModel/MeasurementViewModel";
import { loadSearchViewModule } from "../../components/searchViewModel/SearchViewModel";
import { initSketchViewModel } from "../../components/sketchViewModel/SketchViewModel";
export function createWidget(expandWidget) {
    const expand = new Expand({
        expandTooltip: expandWidget.expandTooltip,
        view: expandWidget.mapview,
        content: expandWidget.content,
        expanded: expandWidget.expanded,
        expandIconClass: expandWidget.expandIconClass
    });
    expandWidget.mapview.ui.add(expand, expandWidget.wedgitPosition);
}
export function Legend(settings) {
    return initLegend(settings);
}
export function searchViewModel(mapView) {
    return loadSearchViewModule(mapView);
}
export function mapToggled(baseMapSettings) {
    addBaseMapToggle(baseMapSettings);
}
export function createLocate(mapView, position) {
    return initLocate(mapView, position);
}
export function drawingOnMap(settings) {
    initSketchViewModel({
        mapView: settings.mapView,
        callbackWhenDone: settings.callbackWhenDone,
        mapContainerId: settings.mapContainerId,
        pointSymbol: settings.pointSymbol,
        polygonSymbol: settings.polygonSymbol,
        polylineSymbol: settings.polylineSymbol,
        controlPosition: settings.controlPosition,
        clear: settings.clear,
        availableTools: settings.availableTools
    });
}
export function MeasurementTools(settings) {
    return Measurement(settings);
}
export function Home(settings) {
    HomeWidget(settings);
}
